/* SK Recommended - Slider drag + add to cart */
(function () {
  'use strict';

  function initSection(container) {
    /* R45: guard contra doble inicializacion */
    if (container.dataset.skInit) return;
    container.dataset.skInit = 'true';

    /* R46: buscar dentro del container */
    var slider = container.querySelector('.sk-recommended__slider');
    if (!slider) return;

    /* Drag to scroll */
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var didDrag = false;

    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      /* No iniciar drag al pulsar una flecha de la mini-galeria */
      if (e.target.closest('.sk-recommended__img-arrow')) return;
      isDown = true;
      didDrag = false;
      slider.classList.add('sk-recommended__slider--grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('sk-recommended__slider--grabbing');
    });

    slider.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('sk-recommended__slider--grabbing');
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      didDrag = true;
      var x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });

    /* Evitar click en links tras drag */
    slider.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    /* Mini-galeria: pasar las imagenes de la card con las flechas */
    slider.addEventListener('click', function (e) {
      var arrow = e.target.closest('.sk-recommended__img-arrow');
      if (!arrow || didDrag) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = arrow.closest('.sk-recommended__image-wrap');
      if (!wrapper) return;

      var imgs = wrapper.querySelectorAll('.sk-recommended__image');
      if (imgs.length < 2) return;

      var current = 0;
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].classList.contains('sk-recommended__image--active')) { current = i; break; }
      }

      var dir = arrow.classList.contains('sk-recommended__img-arrow--next') ? 1 : -1;
      var next = (current + dir + imgs.length) % imgs.length;

      imgs[current].classList.remove('sk-recommended__image--active');
      imgs[next].classList.add('sk-recommended__image--active');

      /* La flecha izquierda solo aparece si no estamos en la primera imagen */
      var prevBtn = wrapper.querySelector('.sk-recommended__img-arrow--prev');
      if (prevBtn) prevBtn.classList.toggle('sk-recommended__img-arrow--hidden', next === 0);
    });

    /* Navegacion por teclado: flechas izq/der para desplazar slider */
    slider.addEventListener('keydown', function (e) {
      var scrollAmount = 200;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
    });

    /* Scroll con rueda del raton */
    slider.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0) return;
      if ((e.deltaY < 0 && slider.scrollLeft <= 0) || (e.deltaY > 0 && slider.scrollLeft >= maxScroll - 1)) return;
      e.preventDefault();
      slider.scrollLeft += e.deltaY;
    }, { passive: false });

    /* Region aria-live para feedback accesible */
    var liveRegion = document.querySelector('.sk-recommended__sr-live');
    function announce(msg) {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      /* Breve retardo para que el screen reader detecte el cambio */
      setTimeout(function () { liveRegion.textContent = msg; }, 50);
    }

    /* Anadir al carrito via AJAX */
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.sk-recommended__action-btn--cart');
      if (!btn || didDrag) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      if (btn.classList.contains('sk-recommended__action-btn--loading')) return;
      btn.classList.add('sk-recommended__action-btn--loading');
      /* Obtener nombre del producto para el anuncio accesible */
      var card = btn.closest('.sk-recommended__card');
      var productName = card ? (card.querySelector('.sk-recommended__product-name') || {}).textContent || '' : '';

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          btn.classList.remove('sk-recommended__action-btn--loading');

          if (data.status) {
            /* Error de la API (ej: stock insuficiente) */
            announce(data.description || 'No se pudo añadir al carrito');
            return;
          }

          btn.classList.add('sk-recommended__action-btn--added');
          announce(productName.trim() + ' añadido al carrito');
          setTimeout(function () {
            btn.classList.remove('sk-recommended__action-btn--added');
          }, 1500);

          /* Emitir evento para actualizar contador del carrito */
          var evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: variantId,
              /* source product-form-component => cart-icon suma el 1 al contador actual.
                 Con otro source lo tomaba como TOTAL y dejaba el badge en 1. */
              data: { source: 'product-form-component', itemCount: 1 }
            }
          });
          document.dispatchEvent(evt);
        })
        .catch(function () {
          btn.classList.remove('sk-recommended__action-btn--loading');
          announce('Error al añadir al carrito');
        });
    });
  }

  /* R44: querySelectorAll para TODAS las instancias */
  var sections = document.querySelectorAll('.sk-recommended');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* R48: re-iniciar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.sk-recommended');
    if (section) initSection(section);
  });
})();
